/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';

import Icon, { IconTypes } from 'components/Icon';
import Tooltip from 'components/Tooltip';
import Currency from 'components/Currency';

function AchPlusFee ({
  iconSize = 16,
  showComplex = false,

  // follows backend AchPlusFee model
  percentRate,
  flatFeeAmount,
  ceiling,
  floor
}) {

  let labelContent = null;
  let tooltipContent = [];

  if (flatFeeAmount) {
    labelContent = <Currency value={flatFeeAmount} />;
    tooltipContent.push(
      <><strong>Payment Fee:</strong> <Currency value={flatFeeAmount} /> per payment </>
    );
  } else if (percentRate) {
    labelContent = <>{percentRate}%</>;

    tooltipContent.push(
      <><strong>Payment Fee:</strong> {percentRate}% </>
    );

    if (ceiling && floor) {
      tooltipContent.push(
        <>
          with a minimum <Currency value={floor} /> and
          maximum <Currency value={ceiling} />
        </>
      );
    } else if (ceiling) {
      tooltipContent.push(
        <>
          up to <Currency value={ceiling} />
        </>
      );
    } else if (floor) {
      tooltipContent.push(
        <>
          with a minimum <Currency value={floor} />
        </>
      );
    }

    tooltipContent.push(
      <> per payment</>
    );


    if (!showComplex && (ceiling || floor)) {
      labelContent = 'Variable';
    }
  }

  return (
    <span>
      {labelContent}{tooltipContent?.length
        ? (
          <Tooltip overlay={<div>
            {tooltipContent.map((c, i) => <span key={i}>{c}</span>)}
          </div>} trigger={['click']}>
            <Icon type={IconTypes.Info} size={iconSize} />
          </Tooltip>
        )
        : null}
      {floor && showComplex
        ? (
          <div>
            Min: <Currency value={floor} />
          </div>
        )
        : null}
      {ceiling && showComplex
        ? (
          <div>
            Max: <Currency value={ceiling} />
          </div>
        )
        : null}
    </span>
  );
}

export default AchPlusFee;